<template>
  <b-container
    fluid
    class="w-100 h-100 m-0 p-0 pt-2"
  >
    <b-row class="w-100 h-100 m-0 p-0">
      <b-col
        cols="4"
        class="h-100 table-column p-0"
      >
        <div class="table-btn-div">
          <b-button
            v-if="anySelected"
            v-b-hover="handleDeleteHover"
            size="sm"
            variant="danger"
            class="m-0 py-0 px-1"
            @click="deleteSelected"
          >
            <b-icon
              v-if="hoverDelete"
              aria-label="Delete Selected"
              icon="x-square"
            />
            <b-icon
              v-else
              aria-label="Delete Selected"
              icon="x-square-fill"
            />
          </b-button>
          <b-button
            v-b-hover="handleAddHover"
            size="sm"
            variant="success"
            class="m-0 py-0 px-1"
            @click="addValue"
          >
            <b-icon
              v-if="hoverAdd"
              aria-label="Add Value"
              icon="plus-square"
            />
            <b-icon
              v-else
              aria-label="Add Value"
              icon="plus-square-fill"
            />
          </b-button>
        </div>
        <div
          ref="divTable"
          class="table-div"
        >
          <vue-table-dynamic
            ref="tableConc"
            :params="paramsTable"
            class="m-0 p-0"
            @cell-change="onCellChange"
            @select="onCellSelected"
            @select-all="onCellSelected"
          />
        </div>
      </b-col>
      <b-col
        cols="8"
        class="h-100"
      >
        <b-container class="h-100">
          <b-row
            align-v="center"
            class="h-100"
          >
            <b-col cols="10">
              <InteractivePlotCPConf
                ref="interactivePlot"
                :show-legends="showLegengsPlotly"
                @change="updateTable"
              />
            </b-col>
            <b-col cols="2">
              <TextInputConfiguration
                :controller="StepFitTextCtrller"
                class="mt-2"
                :sizeinput="'sm'"
              />
            </b-col>
          </b-row>
        </b-container>
        <div class="btn-over">
          <b-button
            v-b-hover="handleDeleteHover"
            v-b-tooltip.hover.bottom="'Erase all'"
            size="sm"
            variant="danger"
            @click="eraseAll"
          >
            <b-icon
              v-if="hoverDelete"
              aria-label="Clear all"
              icon="trash"
            />
            <b-icon
              v-else
              aria-label="Clear all"
              icon="trash-fill"
            />
          </b-button>
          <b-button
            v-if="typeof(fileConc)!=='undefined'"
            v-b-tooltip.hover.bottom="'Reset from File'"
            size="sm"
            variant="info"
            @click="reloadFile"
          >
            <b-icon
              aria-label="Reload File"
              icon="box-arrow-in-down-right"
            />
          </b-button>
          <b-button
            v-b-tooltip.hover.bottom="'Export '+getNotationReportViewer"
            size="sm"
            variant="warning"
            @click="exportCSVConcentrations"
          >
            <b-icon
              aria-label="Reload File"
              icon="box-arrow-up-right"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-form-checkbox
      v-model="showLegengsPlotly"
      class="show-legends-plotly"
      name="checkbox-show-legend"
      :switch="true"
    >
      Show Legends
    </b-form-checkbox>
  </b-container>
</template>

<script>
// https://github.com/TheoXiong/vue-table-dynamic
import { mapGetters, mapActions } from 'vuex'
import InteractivePlotCPConf from '@/components/configWindow/elements/InteractivePlotCP'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import {inputTextConfCtrller,hiddenConfCtrller} from '@/assets/classes/configuration.js'
import VueTableDynamic from 'vue-table-dynamic'
import { TypeAxis } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { DATA_TYPE_CONC } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js'
import { getReportFiles } from '@/common/commonFunctions.js';

const zoneNotify='CronoStepFitCOnfig'

export default {  
  name: 'CronoStepFit',
  components: {
    InteractivePlotCPConf,
    TextInputConfiguration,
    VueTableDynamic,
  },
  props:{
    showLegends:{
      type:Boolean,
      required: false,
      default:false
    },
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data(){
    return { 
      elementsConfig:[],
      StepFitTextCtrller: new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.multiȲ.stepRange`,'Step Fit','It must be larger than 0','50',(value)=>{return !isNaN(value) && value>0}),
      TimesHiddenCtrller: new hiddenConfCtrller(`${ConfigName.BaseCurveFit}.multiȲ.concTimes`,[]),
      configuration:{},
      paramsTable: {
        data: [['Index','Time','Concentration']],
        header: 'row',
        border: true,
        stripe: true,
        edit:{column: [1,2]},
        showCheck: true
      },
      hoverDelete:false,
      hoverAdd:false,
      fileConc:undefined,
      anySelected:false,
      minimumValueX: 0,
      maximumValueX: 0,
      showLegengsPlotly:false
    }
  },
  computed: mapGetters([
    'getStepSizeCPConf',
    'getCurrentReportViewer',
    'getConcentrationsCPConf',
    'getDataCPConf',
    'getNotationReportViewer'
  ]),
  watch: {
    showLegends(){
      this.updateLegendsPlotly()
    },
    getStepSizeCPConf(newValue){//Watch the changes from outside, it could be directly from the graph
      this.StepFitTextCtrller.setValue(newValue)
    },
    getConcentrationsCPConf(newValue){
      this.TimesHiddenCtrller.setValue(newValue)
    }
  },
  created(){
    this.StepFitTextCtrller.setFunction=this.setStepSizeCPConf //Add the setter to the graph vuex
  },
  async mounted() {
    this.elementsConfig=[
      this.StepFitTextCtrller,
      this.TimesHiddenCtrller
    ]
    await this.initializeComponent()
    this.updateAllContentTable()
    this.minimumValueX = Math.min(...this.getDataCPConf.map(dataCP=>{return Math.min(...dataCP.x)}))
    this.maximumValueX = Math.max(...this.getDataCPConf.map(dataCP=>{return Math.max(...dataCP.x)}))
  },
  methods: {
    ...mapActions([
      'setStepSizeCPConf',
      'updateTableConcCPConf',
      'resetConcentrationCPConf',
      'setConcentrationCPConf',
      'deleteConcentrationCPConf',
      'setSelectionFlagCPConf',
      'addConcentrationCPConf',
      'setSelectionFlagCPConf',
      'removeFromInitReqConfWindow',
      'setReportModifiedReportViewer',
    ]),
    isReady(){
      for(let j=0;j<this.elementsConfig.length;j++){
        if(!this.elementsConfig[j].isReady()){
          return false
        }
      }
      return true
    },
    done(){
      this.setSelectionFlagCPConf(false)
      this.removeFromInitReqConfWindow({type:'CHRONO_VALUES', study: this.sectionconfig})
    },
    async initializeComponent(){
      this.configuration=this.getCurrentReportViewer.configuration
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this)) //When the configuration changes, it updates the values with the controllers
      this.TimesHiddenCtrller.setValue(this.getConcentrationsCPConf)
      //Search a file with concentrations
      const reportFiles =  await getReportFiles(this.getCurrentReportViewer)
      this.fileConc = reportFiles.find(file=>file.dataType===DATA_TYPE_CONC)
    },
    onCellChange (rowIndex, columnIndex, rawData) {
      this.setReportModifiedReportViewer()
      const data = typeof(rawData) === 'number' ? rawData : String(rawData).replace(/<\/?[^>]+(>|$)/g, '')
      this.updateTableConcCPConf({row:rowIndex-1,arrIndex:columnIndex-1,newXVal:data})
      this.updatePlotly()
    },
    onCellSelected(){
      this.anySelected = this.$refs.tableConc.getCheckedRowDatas().length > 0
    },
    async verifyData(){
      const halfStepSize = this.getStepSizeCPConf / 2
      let updateAll = false
      const concentrations = this.getConcentrationsCPConf
      if(concentrations.some(conc=>(conc[0]+halfStepSize) > this.maximumValueX)){
        updateAll = true
        for(let j=0;j<concentrations.length;j++){
          if((concentrations[j][0]+halfStepSize) > this.maximumValueX){
            concentrations[j][0] = this.maximumValueX - halfStepSize
          }
        }
        const errTitle='Value out of range'
        const errText=`All the numbers must be less than or equal to ${this.maximumValueX - halfStepSize} (maximumValueX - halfStepSize)`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      if(concentrations.some(conc=>conc[0]-halfStepSize < this.minimumValueX)){
        updateAll = true
        for(let j=0;j<concentrations.length;j++){
          if((concentrations[j][0]-halfStepSize) < this.minimumValueX){
            concentrations[j][0] = this.minimumValueX + halfStepSize
          }
        }
        const errTitle='Value out of range'
        const errText=`All the numbers must be greater than or equal to ${this.maximumValueX - halfStepSize} (minimum + halfStepSize)`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      if(updateAll){
        await this.$nextTick() // Wait to update the table
        this.setConcentrationCPConf(concentrations)
        await this.updatePlotly()
        await this.updateTable()
        return false // Then it does not update again the values
      }
      return true
    },
    async updatePlotly(){
      if(await this.verifyData()){ // Then we avoid unnecessary updates
        this.$refs.interactivePlot.updateConcentrations()
      }
    },
    async updateTable(){
      if(await this.verifyData()){ // Then we avoid unnecessary updates
        this.updateAllContentTable()
      }
    },
    updateAllContentTable(){
      this.paramsTable.data=[['Index','Time',this.getNotationReportViewer]]
      for(let j=0;j<this.getConcentrationsCPConf.length;j++){
        this.paramsTable.data.push([j+1].concat(this.getConcentrationsCPConf[j]))
      }
    },
    handleDeleteHover(hovered) {//Handle the hover on the Add button
      this.hoverDelete = hovered
    },
    handleAddHover(hovered) {//Handle the hover on the Add button
      this.hoverAdd = hovered
    },
    async eraseAll(){
      this.setSelectionFlagCPConf(false)
      try{
        await this.$confirm(
          'This action will remove all the values. Are you sure?',
          'Delete all',
          'question',
          {
            confirmButtonText: 'Remove All',
          }
        )
        this.resetConcentrationCPConf()
        this.$refs.interactivePlot.updateConcentrations()
      }
      catch{
        return
      }
      this.updatePlotly()
    },
    deleteSelected(){
      const selectedRows=this.$refs.tableConc.getCheckedRowDatas()
      for(let j=0;j<selectedRows.length;j++){
        let relativeRowDel=selectedRows[j][0]-j-1 //It should be modified becuase when you delete one row the others move
        this.deleteConcentrationCPConf(relativeRowDel)
      }
      this.updateAllContentTable()
      this.updatePlotly()
    },
    async addValue(){
      this.addConcentrationCPConf(this.getStepSizeCPConf / 2)
      this.updateAllContentTable()
      await this.$nextTick() // Wait to update the table
      const divTable = this.$refs.divTable
      divTable.scrollTop = divTable.scrollHeight;
      this.updatePlotly()
    },
    async reloadFile(){
      this.setSelectionFlagCPConf(false)
      try{
        await this.$confirm(
          'This action will reset the values to your file. Are you sure?',
          'Reset all',
          'question',
          {
            confirmButtonText: 'Reset All',
          }
        )
        const currReportConf = this.getCurrentReportViewer[ExtraConfigKey]
        const newArr= JSON.parse(JSON.stringify(this.fileConc.extractedData))
        const timeFactor = TypeAxis.time.getConvertFactor(currReportConf)
        for(let j=0;j<newArr.length;j++){
          newArr[j][0]*=timeFactor
        }
        this.setConcentrationCPConf(newArr)
        this.$refs.interactivePlot.updateConcentrations()
      }
      catch{
        return
      }
      this.updatePlotly()
    },
    exportCSVConcentrations(){
      if(this.getConcentrationsCPConf.length === 0){
        const infoTitle=`No ${this.getNotationReportViewer}s`
        const infoText=`No ${this.getNotationReportViewer}s found in the current report`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO,infoTitle,infoText,zoneNotify)
        return
      }
      // Create the CSV file
      const csvContent = 'data:text/csv;charset=utf-8,' 
        + this.getConcentrationsCPConf.map(e => e.join('\t')).join('\n');
      const encodedUri = encodeURI(csvContent);

      //Download the file
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = encodedUri;
      a.download = 'CP_TIMES.cntr';
      a.click();
      window.URL.revokeObjectURL(encodedUri);
    },
    updateLegendsPlotly(){
      this.$refs.plot.relayout({showlegend:this.showLegends})
    }
  },
  
}
</script>

<style lang="scss" scoped>
::v-deep .label-input-text{
  font-weight: bold;
  font-size: 0.88rem;
}
.btn-over{
  position:absolute;
  top:0;
  left: 0;
}
.table-div{
  overflow-y: auto;
  height: 90%;
  scroll-behavior: smooth;
}
.table-column{
  box-shadow: 0 4px 8px 0 #ccc;
  border-radius: 10px;
}
::v-deep .v-table-row{
  background-color: #e2ffe0 !important;
}
::v-deep .v-table-row.is-striped{
  background-color: #b1daae !important;
}
</style>